import { render, staticRenderFns } from "./Surephrase.vue?vue&type=template&id=6af1e0a6&"
import script from "./Surephrase.vue?vue&type=script&lang=ts&"
export * from "./Surephrase.vue?vue&type=script&lang=ts&"
import style0 from "./Surephrase.vue?vue&type=style&index=0&id=6af1e0a6&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports